<template>
  <div class="pay-com">
    <el-dialog
      class="dialog-pay"
      :title="title"
      :visible.sync="show"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="sel-combo" v-if="payResult == 'selCombo'">
        <div class="combo-list z-flex">
          <div 
            :class="['combo-item z-flex z-flex-col z-flex-center',activeComboId===item.id?'active':'']" 
            v-for="(item, index) in comboList" 
            :key="index"
            @click="activeComboId = item.id"
          >
            <div class="title">{{item.title}}</div>
            <div class="price"><span class="label">￥</span>{{item.price}}</div>
            <div class="price-ori">￥{{item.priceOri}}</div>
          </div>
        </div>
        <el-button class="btn-confirm-combo" type="primary" round @click="confirmCombo">确认并支付</el-button>
      </div>
      <div class="coupon-list" v-if="payResult == 'selCoupon'">
        <div class="hd">可使用优惠券</div>
        <div class="bd">
          <div class="item" v-for="(item,index) in couponList" :key="index">
            <div class="item-top z-flex z-flex-between" @click.stop="selCoupon(item,index)">
              <div class="item-top-l">
                <div class="title">{{item.name}}</div>
                <div class="use-time">{{item.expiration_date}}</div>
              </div>
              <div class="item-top-r">
                <div class="discount-price"><span>￥</span>{{item.price}}</div>
              </div>
              <i :class="['icon-check el-icon-success',selCouponIdx==index?'active':'']"></i>
            </div>
            <div class="break"></div>
            <div class="item-bottom">
              <div class="desc">
                <el-collapse>
                  <el-collapse-item title="详细说明">
                    <div v-html="item.caption"></div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <el-empty description="暂无可使用的优惠券" v-if="couponList==0"></el-empty>
        </div>
        <div class="bottom z-flex z-flex-between">
          <div class="bottom-l">优惠券已抵扣<span class="discount">￥{{discount}}</span>元</div>
          <el-button class="btn" type="primary" size="medium" @click="toPay">{{selCouponIdx==-1?'不使用优惠券直接支付':'去支付'}}</el-button>
        </div>
      </div>
      <div class="pay-info z-flex z-flex-col z-flex-center" v-if="payResult == ''">
        <div class="title">需支付金额</div>
        <div class="price"><span>￥</span>{{price}}</div>
        <el-image class="paycode" :src="payCode">
          <div slot="placeholder" class="image-slot">
            <i class="el-icon-loading"></i>
            <p>请稍后...</p>
          </div>
          <div slot="error" class="image-slot">
            <i class="el-icon-loading"></i>
            <p>请稍后...</p>
          </div>
        </el-image>
        <div class="tips">微信扫描上方二维码支付</div>
      </div>
      <div class="pay-result z-flex z-flex-col z-flex-center" v-if="payResult == 'success'">
        <el-result icon="success" title="支付成功">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="toUrl('/my/order')">查看订单</el-button>
          </template>
        </el-result>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "payCom",
  props: {
    
  },
  data() {
    return {
      show:false,
      price:'0.00',
      payCode:'',
      payResult:'selCombo',
      title:'选择套餐',
      couponList:[],
      selCouponIdx:-1,
      discount:0,
      payData:[],
      redeemCode:'',
      comboList:[//套餐
        {
          id:9,
          title:'年度会员',
          price:1999,
          priceOri:2999,
          platform: 'proxy_match',
          combo_id: 9,
          recharge_type: 5,
        },{
          id:15,
          title:'五六社员(五年)',
          price:5999,
          priceOri:9999,
          platform: 'proxy_match',
          combo_id: 15,
          recharge_type: 5,
        },
      ],
      activeComboId:9,
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.show = false;
      this.$router.push({
        path:url,
      })
    },
    selCoupon(item,index){
      if(index == this.selCouponIdx){
        this.selCouponIdx = -1;
        this.discount = 0;
        this.redeemCode = '';
      }else{
        this.selCouponIdx = index;
        this.discount = item.price;
        this.redeemCode = this.couponList[this.selCouponIdx].redeem_code;
      }
    },
    confirmCombo(){
      this.comboList.forEach(element => {
        if(element.id == this.activeComboId){
          this.payData = element;
        }
      });
      this.payResult = '';
      this.title = '支付提示';
      this.$parent.confirmToPay(this.payData);
    },
    toPay(){
      this.payResult = '';
      this.title = '支付金额';
      this.payData.price = this.payData.price-this.discount;
      // 抵扣金额不能低于0
      if(this.payData.price <= 0){
        return this.$message.error('支付失败，支付金额不能小于0');
      }
      this.$parent.confirmToPay(this.payData, this.redeemCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-info{
  .title{
    font-size: 18px;
    margin-bottom: 10px;
  }
  .price{
    font-size: 45px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 700;
    color: $colorMain;
    span{
      font-size: 18px;
    }
  }
  .paycode{
    width: 300px;
    height: 300px;
    ::v-deep .image-slot{
      width: 100%;
      height: 100%;
      background-color:#f5f5f5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #777;
      .el-icon-loading{
        font-size:30px;
        margin-bottom: 10px;
      }
    }
  }
  .tips{
    width: 100%;
    text-align: center;
    padding-top: 15px;
    margin-top: 15px;
    border-top: $borderDotted;
  }
}
.coupon-list{
  .hd{
    font-size: 16px;
    font-weight: 700;
    margin: -20px 0 20px;
    height: 20px;
    line-height: 20px;
    border-left: 4px solid $colorMain;
    padding-left:10px;
  }
  .bd{
    max-height: 500px;
    overflow-y: auto;
  }
  .bottom {
    border-top: $borderDashed;
    padding-top: 15px;
    .discount{
      color: $colorMain;
      font-size:16px;
      margin:0 5px;
    }
  }
  .item{
    width: 100%;
    margin-bottom: 20px;
    padding: 10px 20px;
    background-color: #fef0f0;
    border-radius: 10px;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    .item-top{
      padding-bottom: 10px;
      flex-wrap: wrap;
      .item-top-l{
        flex: 1;
        margin-right: 10px;
        @extend %textOverflow;
        .title{
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 10px;
          @extend %textOverflow;
        }
        .use-time{
          font-size: 13px;
          color: #999;
        }
      }
      .item-top-r{
        text-align: center;
        color: $colorMain;
        margin-right: 35px;
        .discount-price{
          font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          font-size: 28px;
          span{
            font-size: 15px;
          }
        }
        .use-price{
          font-size: 14px;
        }
      }
      .icon-check{
        font-size: 25px;
        color: rgba(0,0,0,.5);
        position: absolute;
        right: 10px;
        top: 15px;
        &.active{
          color:$colorMain;
        }
      }
    }
    .break{
      width: 100%;
      height:1px;
      border-bottom: 1px dashed #fb848d;
    }
    .item-bottom{
      align-items: flex-start;
      flex-wrap: wrap;
      padding-top: 5px;
      .desc{
        ::v-deep .el-collapse{
          border:none;
          .el-collapse-item__arrow{
            margin: 0;
          }
        }
        ::v-deep .el-collapse-item__header{
          background:none;
          border:none;
          height: 36px;
          line-height: 36px;
          justify-content: space-between;
          color: #777;
        }
        ::v-deep .el-collapse-item__wrap{
          background:none;
          border:none;
        }
        ::v-deep .el-collapse-item__content{
          padding-bottom: 0;
          color: #777;
        }
      }
    }
    &.item-gery{
      filter: grayscale(100%);
    }
  }
}
.sel-combo{
  .combo-list{
    .combo-item{
      flex: 1;
      border-radius:6px;
      margin:10px;
      padding:20px;
      box-sizing: border-box;
      cursor: pointer;
      background:#f5f5f5;
      border:1px solid #f5f5f5;
      .title{
        font-size:16px;
        font-weight:700;
        margin-bottom:15px;
      }
      .price{
        color:$colorMain;
        font-family:Arial;
        font-weight:700;
        font-size:32px;
        .label{
          font-size:14px;
          margin-right:5px;
          font-weight:normal;
        }
      }
      .price-ori{
        font-size:14px;
        color:#999;
        margin:10px 0 0;
        text-decoration:line-through;
      }
      &.active{
        border-color:$colorMain;
        background:rgb(254, 240, 240);
      }
    }
  }
  .btn-confirm-combo{
    width:70%;
    margin:30px auto 0;
    display:block;
  }
}

</style>
